<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>{{ dataRequest.ticketId ? 'Sửa' : 'Thêm mới' }} ticket</h1>
          <div style="float: right">
            <button type="button" @click="$router.push('/ticket')" class="btn btn-light">
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">
              {{ dataRequest.ticketId ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <div class="form-group row" v-if="dataRequest.ticketId">
                <label class="col-sm-3 col-form-label">
                  Mã ticket<span style="color: red"> *</span>
                </label>
                <div class="col-sm-9">
                  <input
                    disabled
                    type="text"
                    class="form-control datetimes"
                    v-model="dataRequest.ticketCode"
                  />
                </div>
              </div>
              <div class="form" v-if="dataRequest.status != 'PROCESSING'">
                <h6>Thông tin merchant</h6>
                <ValidationProvider rules="required" vid="merchantId" name="Merchant">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Merchant<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <input
                        type="hidden"
                        class="form-control text-left"
                        v-model="merchantSelected"
                      />
                      <input
                        type="text"
                        class="form-control text-left"
                        :disabled="!!dataRequest.ticketId && dataRequest.status != 'NEW'"
                        :value="
                          merchantSelected.merchantName ? `${merchantSelected.merchantName}` : ''
                        "
                        placeholder="Chọn merchant"
                        v-b-modal.select-merchant-dialog
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="" vid="mcLocationBizId" name="Điểm bán">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"> Điểm bán </label>
                    <div class="col-sm-9">
                      <Select2
                        :disabled="!!dataRequest.ticketId && dataRequest.status != 'NEW'"
                        v-model="dataRequest.mcLocationBizId"
                        :options="optionsBizAddress"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <div class="form" v-if="dataRequest.status != 'PROCESSING'">
                <h6>Thông tin phân loại</h6>
                <ValidationProvider rules="required" vid="productCode" name="Dịch vụ">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Dịch vụ<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        :disabled="!!dataRequest.ticketId && dataRequest.status != 'NEW'"
                        v-model="dataRequest.productCode"
                        :options="dataProductCode"
                        @change="getDataCodeDevice()"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" vid="groupCode" name="Nhóm ticket">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Nhóm ticket<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        :disabled="!!dataRequest.ticketId && dataRequest.status != 'NEW'"
                        v-model="dataRequest.groupCode"
                        :options="dataGroupCode"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" vid="typeCode" name="Danh mục ticket">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Danh mục ticket<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        :disabled="!!dataRequest.ticketId && dataRequest.status != 'NEW'"
                        @change="onChangeTypeCode"
                        v-model="dataRequest.typeCode"
                        :options="dataTypeCode"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="" vid="subTypeCode" name="Tiểu mục ticket">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"> Tiểu mục ticket </label>
                    <div class="col-sm-9">
                      <Select2
                        :disabled="
                          !!dataRequest.ticketId && ['PROCESSING'].includes(dataRequest.status)
                        "
                        v-model="dataRequest.subTypeCode"
                        :options="dataSubTypeCode"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <div class="form">
                <h6 v-if="dataRequest.status != 'PROCESSING'">Thông tin mô tả</h6>
                <ValidationProvider
                  rules=""
                  vid="referenceId"
                  name="Mã thiết bị"
                  v-if="dataRequest.status != 'PROCESSING'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"> Mã thiết bị </label>
                    <div class="col-sm-9">
                      <!-- <input
                        :disabled="!!dataRequest.ticketId && dataRequest.status != 'NEW'"
                      type="text"
                      class="form-control"
                      v-model="dataRequest.deviceCode"
                    /> -->
                      <Select2
                        :disabled="
                          !!dataRequest.ticketId && ['PROCESSING'].includes(dataRequest.status)
                        "
                        v-model="dataRequest.deviceCode"
                        :options="dataCodeDevice"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules=""
                  vid="referenceId"
                  name="Mã giao dịch"
                  v-if="dataRequest.status != 'PROCESSING'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"> Mã giao dịch </label>
                    <div class="col-sm-9">
                      <input
                        :disabled="!!dataRequest.ticketId && dataRequest.status != 'NEW'"
                        type="text"
                        class="form-control"
                        v-model="dataRequest.referenceId"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="minMaxName_4" vid="content" name="Mô tả">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">Mô tả</label>
                    <div class="col-sm-9">
                      <textarea
                        type="text"
                        class="form-control"
                        v-model="dataRequest.content"
                      ></textarea>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules=""
                  vid="sourceInform"
                  name="Nguồn báo"
                  v-if="dataRequest.status != 'PROCESSING'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"> Nguồn báo </label>
                    <div class="col-sm-9">
                      <Select2
                        :disabled="
                          !!dataRequest.ticketId && ['PROCESSING'].includes(dataRequest.status)
                        "
                        v-model="dataRequest.sourceInform"
                        :options="Config.ticketSource"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="informAt.startDate"
                  name="TG thông báo"
                  v-if="dataRequest.status != 'PROCESSING'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      TG thông báo<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <DateRangePicker
                        class="w-100"
                        :ranges="false"
                        :show-week-numbers="false"
                        :single-date-picker="true"
                        v-model="dataRequest.informAt"
                        :locale-data="Config.localeData"
                        :timePicker="true"
                        :timePicker24Hour="true"
                        :disabled="!!dataRequest.ticketId && dataRequest.status != 'NEW'"
                      >
                        <template v-slot:input="picker">
                          {{ picker.startDate | formatDate('HH:mm DD/MM/YYYY') }}
                        </template>
                      </DateRangePicker>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules=""
                  vid="informMethod"
                  name="Hình thức báo"
                  v-if="dataRequest.status != 'PROCESSING'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">Hình thức báo</label>
                    <div class="col-sm-9">
                      <Select2
                        :disabled="
                          !!dataRequest.ticketId && ['PROCESSING'].includes(dataRequest.status)
                        "
                        v-model="dataRequest.informMethod"
                        :options="Config.informMethod"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <div class="">
                <h6 v-if="dataRequest.status != 'PROCESSING'">Thông tin xử lý</h6>
                <ValidationProvider
                  rules=""
                  vid="assignee"
                  name="Người tiếp nhận"
                  v-if="dataRequest.status != 'PROCESSING'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"> Người tiếp nhận </label>
                    <div class="col-sm-9">
                      <Select2 v-model="dataRequest.recieverUser" :options="optionsStaff" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules=""
                  vid="assignee"
                  name="Người giám sát"
                  v-if="dataRequest.status != 'PROCESSING'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"> Người giám sát </label>
                    <div class="col-sm-9">
                      <Select2
                        v-model="dataRequest.supervisorUser"
                        :options="optionsUserSupervisor"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules=""
                  vid="assignee"
                  name="Người theo dõi"
                  v-if="dataRequest.status != 'PROCESSING'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"> Người theo dõi </label>
                    <div class="col-sm-9">
                      <Select2MultipleControl
                        :settings="{ closeOnSelect: false }"
                        v-model="followerUser"
                        :options="optionsStaff"
                      >
                      </Select2MultipleControl>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules=""
                  vid="currentState"
                  name="Hiện trạng"
                  v-if="dataRequest.ticketId"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">Hiện trạng</label>
                    <div class="col-sm-9">
                      <Select2
                        @change="checkCurrent(dataRequest.currentStateCode)"
                        v-model="dataRequest.currentStateCode"
                        :options="dataCurrentState"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                    <div class="col-sm-9" v-if="dataRequest.currentState === '0'"></div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="currentState"
                  name="Hiện trạng"
                  v-if="dataRequest.currentStateCode === 'OTHER' && checkCurrentState"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"
                      >Điền hiện trạng<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="currentState" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6">
              <UploadMultiple
                @syncFile="syncFile"
                :lsData="fileUploads"
                :maxFile="20"
                uniqueKey="images"
              />
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <SelectMerchant @selectMerchant="onSelectMerchant" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { ContractService } from '@/services/contract.service'
  import { MerchantService } from '@/services/merchant.service'
  import { StaffService } from '@/services/staff.service'
  import { CommonService } from '@/services/common.service'
  import { TicketService } from '@/services/ticket.service'
  import { mapGetters } from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'
  import Config from '@/thirdParty/config'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import SelectMerchant from '@/components/SelectMerchant.vue'
  import moment from 'moment'
  import { v4 as uuidv4 } from 'uuid'

  export default {
    name: 'request-ticket',
    data() {
      return {
        Config,
        dataRequest: {
          informAt: {},
          merchantId: '',
        },
        dataTypeCode: [],
        dataSubTypeCode: [],
        dataGroupCode: [],
        dataProductCode: [],
        optionsStaff: [],
        optionsUserSupervisor: [],
        optionsBizAddress: [],
        merchantSelected: {},
        dataUser: JSON.parse(localStorage.getItem('userData')),
        showLoading: false,
        fileUploads: [],
        followerUser: [],
        dataCurrentState: [],
        currentState: '',
        dataCodeDevice: [],
        checkCurrentState: false,
      }
    },
    components: { UploadMultiple, SelectMerchant },
    created() {
      TicketService.fetchGroup()
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name })) ?? [])
        .then(s => (this.dataGroupCode = s))
      TicketService.fetchProduct()
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name })) ?? [])
        .then(s => (this.dataProductCode = s))
      TicketService.fetchCategory()
        .then(
          s => s.data?.map(s => ({ id: s.code, text: s.name, isManualUpdate: s.isHandmade })) ?? []
        )
        .then(s => (this.dataTypeCode = s))
      TicketService.fetchSubCategory()
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name })) ?? [])
        .then(s => (this.dataSubTypeCode = s))
      this.getStaff()
      this.fetchUserSupervisor()
      this.fetchData()
      if (!this.$route.params.id) {
        const timestamp = Date.now()
        this.dataRequest.informAt = {
          startDate: moment(timestamp).valueOf(),
          endDate: moment(timestamp).valueOf(),
        }
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async getStaff() {
        try {
          const response = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          this.optionsStaff = response.data.map(item => ({
            id: item.userId,
            text: item.name,
          }))
        } catch (error) {
          console.log(error)
        }
      },
      syncFile(files) {
        this.fileUploads = files
      },
      onSelectMerchant(mc) {
        this.merchantSelected = mc
        this.optionsBizAddress =
          mc.merchantBusinessAreas?.map(s => ({ id: s.id, text: s.areaAddress })) ?? []
        this.dataRequest.mcLocationBizId = this.optionsBizAddress[0].id
        this.dataRequest.merchantId = mc.customerId
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
      preareDataEdit(params) {
        const data = params
        if (data.currentStateCode === 'OTHER') {
          data.currentState = this.currentState
        } else if (data.currentStateCode && data.currentStateCode !== 'OTHER') {
          const findItem = this.dataCurrentState.find(
            item => item.id === this.dataRequest.currentStateCode
          )
          data.currentState = findItem.text
        }
        return data
      },
      async submitRequest() {
        try {
          this.showLoading = true
          if (Object.keys(this.dataRequest.informAt).length === 0)
            this.showFailMx('Thời gian thông báo không được để trống')
          else {
            const params = cloneDeep(this.dataRequest)
            params.informAt = moment(params.informAt.startDate).valueOf()
            const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
            params.ticketImages = files.map(s => s.urlFile)
            params.followerUser = this.followerUser
            if (this.dataRequest.ticketId) {
              params.currentState =
                params.currentState === '0' ? this.currentState : params.currentState
              const body = this.preareDataEdit(params)
              const response = await TicketService.update(body)
              if (response.success) {
                this.showSuccessMx('Cập nhật ticket thành công').then(() =>
                  this.$router.push(`/ticket/${this.dataRequest.ticketId}`)
                )
              } else this.showFailMx(response.message)
            } else {
              const response = await TicketService.insert(params)
              if (response.success) {
                this.showSuccessMx('Thêm mới ticket thành công').then(() =>
                  this.$router.push(`/ticket/${response.data.ticketId}`)
                )
              } else this.showFailMx(response.message)
            }
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchData() {
        const ticketId = this.$route.params.id
        if (ticketId) {
          try {
            this.showLoading = true
            const res = await TicketService.getOne({
              ticketId: ticketId,
            })
            const mcInfo = await MerchantService.merchantDetail({
              customerId: res.data.merchantInfo.customerId,
            })
            this.merchantSelected = mcInfo.data
            this.onSelectMerchant(mcInfo.data)
            this.dataRequest = {
              ticketId: ticketId,
              ticketCode: res.data.ticketCode,
              referenceId: res.data.referenceId,
              mcLocationBizId: res.data.bizLocation?.id,
              typeCode: res.data.typeCode,
              subTypeCode: res.data.subTypeCode,
              content: res.data.content,
              sourceInform: res.data.sourceInform,
              userInform: res.data.userInform,
              productCode: res.data.productCode,
              deviceCode: res.data.deviceCode,
              groupCode: res.data.groupCode,
              informMethod: res.data.informMethod,
              isManualUpdate: res.data.isManualUpdate,
              assignee: res.data.assignee?.userId ?? null,
              userRelation: res.data.userRelation?.userId ?? null,
              merchantId: res.data.merchantInfo.customerId,
              recieverUser: res.data.processUserReceiver ? res.data.processUserReceiver.userId : '',
              supervisorUser: res.data.processUserSupervisor
                ? res.data.processUserSupervisor.userId
                : '',
              informAt: {
                startDate: moment(res.data.informAt).valueOf(),
                endDate: moment(res.data.informAt).valueOf(),
              },
              ticketImages: res.data.ticketImages,
              status: res.data.status,
              currentState: res.data.currentState,
            }
            this.getDataCodeDevice()
            if (res.data.currentStateCode === 'OTHER') {
              this.checkCurrentState = true
              this.currentState = res.data.currentState
            }
            this.dataRequest.currentStateCode = res.data.currentStateCode
            if (this.dataRequest.typeCode && this.dataRequest.typeCode != '') {
              this.getDataCurrentStateV2()
            }
            const mappingData = (arr, type) =>
              arr.forEach(url => {
                const ar = { name: url, url, type, id: uuidv4() }
                this.fileUploads.push(ar)
              })
            mappingData(this.dataRequest.ticketImages, 'images')
            this.followerUser = res.data.processUserFollowers.map(item => item.userId)
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
      checkCurrent(code) {
        if (code === 'OTHER') {
          this.checkCurrentState = true
        } else {
          this.checkCurrentState = false
        }
      },
      onChangeTypeCode(e) {
        this.dataRequest.isManualUpdate = this.dataTypeCode.find(s => s.id === e)?.isManualUpdate
        this.getDataCurrentStateV2()
      },
      async fetchUserSupervisor() {
        try {
          this.showLoading = true
          const params = {
            typeSales: [
              'SALE_DIRECTOR',
              'OPERATOR_SYSTEM',
              'REGION_DIRECTOR',
              'SALE_ADMIN',
              'SALE_MANAGER',
              'SALE_LEADER',
              'AFTER_SALE_LEADER',
              'TELESALE_LEADER',
              'TRAINER_LEADER',
              'MARKETING',
            ],
          }
          const response = await TicketService.getUserSupervisor(params)
          this.optionsUserSupervisor = response.data.map(item => ({
            id: item.id,
            text: item.name,
          }))
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async getDataCurrentState() {
        try {
          const params = { applyFor: [this.dataRequest.typeCode] }

          const response = await TicketService.fetchCurrentStateTicket(params)
          if (response.code === 1000) {
            this.dataCurrentState =
              response.data.map(item => ({ text: item.name, id: item.code })) ?? []
            this.dataCurrentState.push({ text: 'Khác', id: 'OTHER' })
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getDataCurrentStateV2() {
        try {
          const params = {
            category: this.dataRequest.typeCode,
            fromState: this.dataRequest.currentStateCode,
          }

          const response = await TicketService.transitionActionResultNextStep(params)
          if (response.code === 1000) {
            this.dataCurrentState =
              response.data.map(item => ({ text: item.name, id: item.code })) ?? []
            this.dataCurrentState.push({ text: 'Khác', id: 'OTHER' })
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message)
        }
      },
      async getDataCodeDevice() {
        try {
          this.showLoading = true
          const params = {
            page: 1,
            page: 1,
            limit: 15,
            customerId: this.dataRequest.merchantId,
            serviceTypes: [this.dataRequest.productCode],
          }

          const response = await ContractService.getListContract(params)
          if (response.code === 1000) {
            this.getDataRecallDevice(response.data.contractList[0])
          }
        } catch (error) {
          console.log(error.message)
        } finally {
          this.showLoading = false
        }
      },

      async getDataRecallDevice(data) {
        try {
          this.showLoading = true
          const params = {
            contractId: data.id,
          }

          const response = await ContractService.listRecallDevice(params)
          if (response.code === 1000) {
            const dataRes = response.data.deviceRecalls
            this.dataCodeDevice = dataRes.map(e => {
              return {
                text: `${e.device.name} - ${e.device.serialNumber}`,
                id: e.device.serialNumber,
              }
            })
          }
        } catch (error) {
          console.log(error.message)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
